export default __webpack_public_path__ + "static/media/EhsanSaya.6470dbe4.png";